(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RetirementNestEggCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["RetirementNestEggCalculator"] = factory();
	else
		root["RetirementNestEggCalculator"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition